import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import qs from 'qs'
import merge from 'lodash/merge'
import { Message } from 'element-ui';
import {clearLoginInfo} from '@/utils'

const apiUrl = 'http://chinajiemuku.com/guoshi'
const fileUrl = 'http://chinajiemuku.com/guoshi/file'
// const apiUrl = 'http://guoshi.getf.vip/guoshi'
// const fileUrl = 'http://guoshi.getf.vip/files'
// const apiUrl = 'http://192.168.10.42:8084'

const http = axios.create({
  timeout: 1000 * 30,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  if(config.isData){
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded' // 用formdata上传
  }
  config.headers['Authorization'] = Vue.cookie.get('Token') // 请求头带上token
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
  let data = response.data
  if (data && (data.code === 401 || data.code === 40101)) { // 401, token失效
    Message.warning('用户登录过期，请重新登录');
    clearLoginInfo()
    router.push({name: 'login'})
  }
  if(data && (data.code != 0 && data.code != 200 && data.code != 401 && data.code != 40101)){
    Message.warning(data.msg || data.message);
  }
  return response
}, error => {
  if (error.message === 'Network Error' || error == 'Request failed with status code 401') {
    clearLoginInfo()
    router.push({name: 'login'})
  }
  return Promise.reject(error)
})

/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
http.adornUrl = (actionName) => {
  // 非生产环境 && 开启代理, 接口前缀统一使用[/proxyApi/]前缀做代理拦截!
  return (process.env.NODE_ENV !== 'production' && process.env.OPEN_PROXY ? '/guoshi/' : apiUrl) + actionName
}

/**
 * 请求图片地址处理
 * @param {*} actionName action方法名称
 */
http.adornFileUrl = (actionName) => {
  // 非生产环境 && 开启代理, 接口前缀统一使用[/proxyApi/]前缀做代理拦截!
  return (process.env.NODE_ENV !== 'production' && process.env.OPEN_PROXY ? '/guoshi/' : fileUrl) + actionName
}

/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefaultParams 是否开启默认参数?
 */
http.adornParams = (params = {}, openDefaultParams = true) => {
 
  return openDefaultParams ? merge(params) : params
}

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefaultData 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
http.adornData = (data = {}, openDefaultData = true, contentType = 'json') => {
  data = openDefaultData ? data : data
  if (contentType === 'file') { // 带文件上传
    let form = new FormData()
    for (let key in data) {
      form.append(key, data[key])
    }
    return form
  }
  return contentType === 'json' ? JSON.stringify(data) : qs.stringify(data)
}

export default http 



// WEBPACK FOOTER //
// ./src/api/index.js